module.exports = __webpack_public_path__ + "img/iem_health_logo_140.9818cf45.png";